import { render, staticRenderFns } from "./ClaimAnomaly.vue?vue&type=template&id=ff6a2304"
import script from "./ClaimAnomaly.vue?vue&type=script&lang=ts"
export * from "./ClaimAnomaly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports